import outlined from './outlined';
import filled from './filled';
import misc from './misc';
import threeD from './3d';
import emoji from './emoji';
import apps from './apps';

export default {
  ...outlined,
  ...filled,
  ...misc,
  ...threeD,
  ...emoji,
  ...apps
};
